import { truckLabel, formatNo } from './truckCatalog';
import { loadsText } from './truckSuggest';

// «Tippbil, 3-akslet», «Tippbil, 4-akslet + henger», «Container 10 m³ (krokløft)», eller null for eldre ordre uten bilvalg.
export function orderTruckText(order) {
  if (!order?.truckCategory) return null;
  if (order.containerSize > 0) return `Container ${formatNo(order.containerSize)} m³ (krokløft)`;
  return truckLabel(order.truckCategory, order.truckAxlesMin, order.truckTrailer === true);
}

// «2 lass à 10 t» (tonn) eller «2 lass à 10 sekker», eller null ved ett lass eller manglende data.
export function orderLoadsText(order) {
  return loadsText({ loads: order?.loadCount, tonsPerLoad: order?.tonsPerLoad }, order?.unit === 'bags' ? 'bags' : 'tons');
}

// «Bil 12 t · Henger 14 t» for ordre med henger, ellers null.
export function orderLoadSplitText(order) {
  const s = order?.loadSplit;
  if (order?.truckTrailer !== true || !s || !(s.truck > 0) || !(s.trailer > 0)) return null;
  return `Bil ${formatNo(s.truck)} t · Henger ${formatNo(s.trailer)} t`;
}

// «Kranløft: 1,5 t på 10 m» for ordre med oppgitt løft, ellers null.
export function orderCraneLiftText(order) {
  const l = order?.craneLift;
  return l?.tons > 0 && l?.meters > 0 ? `Kranløft: ${formatNo(l.tons)} t på ${formatNo(l.meters)} m` : null;
}
